exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".a7gEcAZDZzRRfeaM5jaiX {\n  background: #fff;\n  border-top: 1px solid #ccc;\n  padding: 0;\n}\n._3vfCzRstekiFHaldv1FsSC {\n  display: flex;\n  flex-flow: row nowrap;\n  padding: 0.5rem 0.5rem;\n}\n._2VJKvHWHDBIl_L1uxlzYxT {\n  background: #eef;\n}\n._1IXv8yjFjx-uE83Yl1Lf7Z {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 0 0 7rem;\n  font-weight: bold;\n}\n._1_BYvIp61UXkxVYVgs51CS {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 0 0 3rem;\n}\n._2pug5iIrjwAnFlXDPfgSv4 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1 1 auto;\n}\n._2pug5iIrjwAnFlXDPfgSv4 .label {\n  margin-right: 0.3rem;\n}\n", ""]);

// exports
exports.locals = {
	"score": "a7gEcAZDZzRRfeaM5jaiX",
	"player-row": "_3vfCzRstekiFHaldv1FsSC",
	"player-me": "_2VJKvHWHDBIl_L1uxlzYxT",
	"player-name": "_1IXv8yjFjx-uE83Yl1Lf7Z",
	"player-score": "_1_BYvIp61UXkxVYVgs51CS",
	"player-labels": "_2pug5iIrjwAnFlXDPfgSv4"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/score.styl
 ** module id = 271
 ** module chunks = 0
 **/